import { render, staticRenderFns } from "./faturacao-vendas.vue?vue&type=template&id=074d2870&scoped=true&"
import script from "./faturacao-vendas.vue?vue&type=script&lang=js&"
export * from "./faturacao-vendas.vue?vue&type=script&lang=js&"
import style0 from "./faturacao-vendas.vue?vue&type=style&index=0&id=074d2870&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "074d2870",
  null
  
)

export default component.exports